<template>

<div class="povrsine">
     <!-- <div class="glava">
        Slika v glavi
      </div>
  -->
    <div class="info">
          <h2> Obrazec površin gerkov</h2>
      </div>
      
      <div class="kmg">
        <div class="nosilec"><div>{{ pridelovalec.naziv }}</div><div>Priimek in ime</div></div>
        <div class="naslov"><div>{{pridelovalec.naslov}} {{pridelovalec.postnastevilka}} - {{pridelovalec.posta}}</div><div>Naslov</div></div>
        <div class="kontrolnast"><div>{{shema.kontrolnaStevilka}}</div><div>Kontrolna številka</div></div> 
      </div>
      <div class="gerki">
    
    <table id="gerki">
         <colgroup>
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:30%">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:auto">
        
        <col style="width:auto">
  </colgroup> 
        <thead>
        <tr>
            <th>Zap. št.</th>
            <th>&check;</th>
            <th>BLOK_ID</th>
            <th>GERK_PID</th>
            <th class="raba">Opis</th>
            <th>Kultura</th>
            <th>Domače ime</th>
            <th>Pov (a)</th>
            
            <th>E</th>
            <th>P</th>
            <th>N</th>
            <th>K</th>
            

        </tr>
    </thead>
  <tr v-for="gerk in gerki" :key="gerk.gerkpid">
    <td>{{ gerk.st}}</td>
    <td></td>
    <td>{{ gerk.blokid}}</td>
    <td>{{ gerk.gerkpid}}</td>
    <td>{{ gerk.raba}}</td>
    <td></td>
    <td>{{ gerk.domaceime}}</td>
    <td>{{ gerk.povrsina.toFixed(0)}}</td>
    <td>{{ gerk.status=="E"?"&check;":""}}</td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr class="vsota"><td>Število:</td><td>{{gerki.length}}</td><td colspan="3"></td><td>Vsota površin:</td><td>{{gerki.reduce((a,i)=>{return a+i.povrsina;},0).toFixed()}}</td><td colspan="5"></td></tr>
</table>

      </div>
    <div class="dodatni-podatki">
        <div class="povrsina">
            <table>
                 <colgroup>
        <col>
        <col>
        <col>
        <col style="width:25%">

  </colgroup> 
                <thead>
                    <tr><th colspan="3">Skupna površina posamezne rabe vključene v postopek certificiranja ekološkega kmetijstva</th></tr>
                    <tr><th>RABA</th><th>Skup. pov (a)</th><th>Cert. pov (a)</th><th>Status</th></tr>
                </thead>
                <tbody>

                    <tr v-for="vsota in vsotePovrsin"><td>{{vsota.ime}}</td><td> {{vsota.povrsina.toFixed()}} </td><td></td><td></td></tr>
                    <tr><td>Ostalo</td><td>{{(gerki.reduce((a,i)=>{return a+i.povrsina;},0)-vsotePovrsin.reduce((a,i)=>{return a+i.povrsina;},0)).toFixed()}}</td><td></td><td></td></tr>
                    <tr class="vsota"><td>SKUPAJ</td><td>{{gerki.reduce((a,i)=>{return a+i.povrsina;},0).toFixed()}}</td><td></td><td></td></tr>
                </tbody>
                <tfoot>
                    <tr><td colspan="3">Ostalo (gobe, samonikle rastline... brez zemljišč)</td></tr>
                </tfoot>
            </table>
        </div>
        <div class="kulture">
             <table>
                  
                <thead>
                    <tr><th colspan="8">Statusi (E,P1,P2,P3, K) posameznih kultur s količinami. Za površine z mešano rabo zelenjave, zelišč...se lahko v to tabelo vpiše skupna površina mešane rabe s skupnim pridelkom ter priloži priloga s seznamom kultur in količin ali izpolni spodnja tabela.</th></tr>
                    <tr><th>Kultura</th><th>Pov (a)</th><th>Količina</th><th>Status</th><th>Kultura</th><th>Pov (a)</th><th>Količina</th><th>Status</th></tr>
                </thead>
                <tbody>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    
                    
                </tbody>
                
            </table>
        </div>
    </div>
    <div class="seznam-kultur">
        <div>SEZNAM KULTUR MEŠANE RABE: </div>
        <div>
            <div class="okvir"></div>
            <div class="okvir"></div>
        </div>
    </div>
    <div class="podpis">
         <div class="podpisstranke">Podpis izvajalca</div>
        <div class="datumzig">Datum</div>
        <div class="ko">Podpis kontrolorja</div> 
    </div>
    <!--  <div class="noga"></div> -->

</div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex'


export default {
    props: ["sezona","pridelovalecid"]
    ,
    
    created () {
       
      if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};

    this.naloziPodatke();

    },
     data:function() {
        return {
          shema:{},
            preslikava:[
 {
   "rabaid": 1180,
   "raba": "Trajne rastline na njivskih površinah",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1610,
   "raba": "Kmetijsko zemljišče v pripravi",
   "skupina": "Njivske površine"
 },
 {
   "rabaid": 1191,
   "raba": "Rastlinjak, kjer pridelava ni v tleh",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1161,
   "raba": "Hmeljišče v premeni",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1320,
   "raba": "Travinje z razpršenimi neupravičenimi značilnostmi",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1230,
   "raba": "Oljčnik",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1100,
   "raba": "Njiva",
   "skupina": "Njivske površine"
 },
 {
   "rabaid": 1192,
   "raba": "Rastlinjak s sadnimi rastlinami",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1212,
   "raba": "Matičnjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1300,
   "raba": "Trajni travnik",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1131,
   "raba": "Začasno travinje",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1420,
   "raba": "Plantaža gozdnega drevja",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1221,
   "raba": "Intenzivni sadovnjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1181,
   "raba": "Trajne rastline na njiv. površinah, kjer pridelava ni v tleh",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1190,
   "raba": "Rastlinjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1170,
   "raba": "Jagode na njivi",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1411,
   "raba": "Površine za ukrep odprava zaraščanja",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1160,
   "raba": "Hmeljišče",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1240,
   "raba": "Ostali trajni nasadi",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1211,
   "raba": "Vinograd",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1222,
   "raba": "Ekstenzivni oz. travniški sadovnjak",
   "skupina": "Specialne kulture"
 }
],
vrste:[{ime:"Njivske površine",vsota:null},{ime:"Travinje",vsota:null},{ime:"Specialne kulture",vsota:null}]
        }
    },
    computed: {
          ...mapState({gerki(state) {
            if(state.gerk.gerk)
                return state.gerk.gerk.sort(
            (a,b)=>{
                if (a.blokid>b.blokid)
                    return 1;
                else if(a.blokid==b.blokid)
                    return a.gerkpid>b.gerkpid?1:-1
                else
                    return -1;
                    }).filter(g=>g.izbrisan!=true); //izbrisani se ne tiskajo
            else
                    return state.gerk.gerk;

        }}),
       //...mapState('gerk', ['gerk']),
        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('users', ['sezonePisanje']),
        vsotePovrsin:
        {
           get() {
            if(!this.gerki)
              return [];
            else{
                    var tmp=[];
                    for (var vrsta of this.vrste){
                        var tmpe={ime:vrsta.ime};
                        tmpe.povrsina=this.gerki.filter(g=>this.preslikava.find(p=>p.rabaid==g.rabaid)?.skupina==vrsta.ime).reduce((partialSum, a) =>(partialSum + a.povrsina), 0);
                        tmp.push(tmpe);

                    }
                        return tmp;
                }
            }             
          },
           
        },
   
    methods: {

        ...mapActions('gerk', ['load','save']),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        naloziPodatke(){

            var thisComp=this;
             this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(()=>{
              thisComp.shema=thisComp.pridelovalec.sheme.find(s=>s.shema=="EKO PRI"&&s.sezona==this.dataSezona.sezona);
              thisComp.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec.kmgmid}).then(()=>{
                    //porihtaj kontakte!!!
                    console.log(this.pridelovalec);
                    let kontakt=this.pridelovalec.kontakt.find(k=>k.vloga=="nosilec kmg");
                        if(!kontakt)
                            kontakt=this.pridelovalec.kontakt.find(k=>k.glavni);
                        if(!kontakt)
                            kontakt=this.pridelovalec.kontakt[0];
                    
                    if(kontakt){
                      Vue.set(this.pridelovalec,"naziv",kontakt.naziv)
                      Vue.set(this.pridelovalec,"naslov",kontakt.naslov)
                      Vue.set(this.pridelovalec,"posta",kontakt.posta)
                      Vue.set(this.pridelovalec,"postnastevilka",kontakt.postnastevilka)
                     
                    }

              });
             });
            
           },
    },

}

</script>


<style scoped>
@import '../styles/landscape.css';

.povrsine {
      margin: 15mm 15mm 15mm 15mm; 

}
.povrsine h2 {
      color:black;


}
.povrsine sub {
    font-size:smaller;
}


.glava{
    height:40mm;
    display:flex;
    align-items:center;
    justify-content:center;
    border:1px solid black;
}
.kmg{
    margin-top:8mm;
    display:flex;

}
.kmg>div{
    border:1px solid black;
}
.kmg div {
    text-align:center;
}
.kmg div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.kmg div div:nth-child(2) {
    font-size:0.8em;
}
.kmg .nosilec {
    flex-grow:2;
}
.kmg .naslov {
    flex-grow:3;
}
.kmg .kontrolnast {
    flex-grow:1;
}


.info {
    margin-top:8mm;
}

.gerki {
     margin-top:8mm;   
}

.povrsine table#gerki{
    width:100%;
}
.povrsine table#gerki,.povrsine table#gerki th,.povrsine table#gerki td {
    border:1px solid black;
    border-collapse:collapse;

}
.povrsine table#gerki td, .povrsine table#gerki th {
    padding:0 1mm;
    white-space: nowrap;
    width:1px;

}
.povrsine table#gerki .vsota, .dodatni-podatki table .vsota {
    font-weight:bold;
}

.podpis{
    margin-top:8mm;
    display:flex;

}
.podpis>div{
    border:1px solid black;
    padding-bottom:10mm;
}
.podpis div {
    text-align:center;
}
.podpis div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.podpis div div:nth-child(2) {
    font-size:0.8em;
}
.podpis .podpisstranke {
    flex-grow:3;
}
.podpis .datumzig {
    flex-grow:1;
}
.podpis .ko {
    flex-grow:3;
}

.dodatni-podatki{
    display:flex;
     justify-content: space-between;
    margin-top:8mm;
}

.povrsine .dodatni-podatki table,.povrsine .dodatni-podatki table th,.povrsine .dodatni-podatki table td {
    border:1px solid black;
    border-collapse:collapse;

}
.povrsine.dodatni-podatki table td, .povrsine .dodatni-podatki table th {
    padding:0 1mm;
    white-space: nowrap;
    

}
.dodatni-podatki table{
   
    table-layout: fixed;
}
.dodatni-podatki table thead tr:nth-child(1) th{
    word-wrap: break-word; 
    white-space: break-spaces;
    font-size:0.8em;
   
   
}
.dodatni-podatki .kulture {
    flex-grow:5;
    flex-shrink:1;
        width:80%;
        margin-left:8mm;
}
.dodatni-podatki .povrsina  col:nth-child(2),.dodatni-podatki .povrsina  col:nth-child(3){
    width:1px;
    }


.dodatni-podatki .povrsina {
    flex-grow:1;
    flex-shrink:1;
    width:35%;
}
.dodatni-podatki .povrsina tfoot {
    
}

.seznam-kultur {
    display:flex;
    margin-top:8mm;
    height: 2.5em;
}

.seznam-kultur>div:nth-child(1){
    display:flex;
}

.seznam-kultur>div:nth-child(2){
    border: 1px solid black;
    flex-grow:1;
    margin-left:8mm;
}
.seznam-kultur>div:nth-child(2)>div:nth-child(1){
    height: 50%;
    border-bottom: 1px solid black;

}
.dodatni-podatki table td:nth-child(2) 
{
text-align:right;
}
@media print {
  .dodatni-podatki {
    break-inside: avoid;
  }
}
</style>
